import React from "react";
import { makeStyles } from "@mui/styles";
import CustomAvatar from "../../../general_components/CustomAvatar";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import { IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { getAPIEndpointUrl } from "../../../utils/ServerRequestModifier";

const useStyles = makeStyles({
  image: {
    width: "100%",
    height: 150,
    minHeight: 150,
    borderRadius: 15,
    position: "absolute",
    backgroundColor: "#eee",
    objectFit: "cover",
    resizeMode: "contain",
  },
});


export default function AddGallaryImages({RawImages, setRawImages, Images, setImages, isNewsFile, setFullRawImage, setIsNewsFile,editMode}) {

  const classes = useStyles();
  const theme = useTheme();
  const ref = React.useRef(null);


  let processedFiles = [];

  const getProfileImageFile = async (e) => {

    const files = e.target.files;

    if (files.length > 0) {
      try {
        const handleLoadImage = (name, file, fr) => {
          fr.onload = function (e) {
            processedFiles.push({
              image: e.target.result,
              file: new File([file], name),
            });

            if (processedFiles.length === files.length) {
              setRawImages([...RawImages, ...processedFiles]);
              setImages([...Images, ...processedFiles]);

            }
          };

          fr.readAsDataURL(file);
        }

        const handleCondition = (name) => {
          return Images.some((existingFile) => existingFile.file.name === name);
        }

        // If file is single
        if(files.length === 1) {
          const file = files[0];
          const fr = new FileReader();
          // Generate a random name for the file
          const name = `image_${file.name.split('.')[0]}.jpeg`;
          if(handleCondition(name)) {
            alert("File already exists");
            return;
          }
          handleLoadImage(name, file, fr);
        } else {
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fr = new FileReader();
            // Generate a random name for the file
            const name = `image_${file.name.split('.')[0]}.jpeg`;
            if(handleCondition(name)) {
              alert("File already exists");
              return;
            }
            handleLoadImage(name, file, fr);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  
  const removeImage = (index) => {
    const updatedImages = [...Images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);

    const updatedRawImages = [...RawImages];
    updatedRawImages.splice(index, 1);
    setRawImages(updatedRawImages);
  };

  return (
    <div>
      <Typography
        variant={"caption"}
        style={{ lineHeight: 1 }}
        color={"textSecondary"}
      >
        Project Gallery
      </Typography>
      <div>
        <input
          ref={ref}
          style={{ display: "none" }}
          onChange={(e) => getProfileImageFile(e)}
          type={"file"}
          name={"files[]"}
          multiple
          required={true}
        />
        <div
          style={{ position: "relative", display: "flex", flexWrap: "wrap" }}
        >
          {editMode
            ? Images.map((item, index) => (
                <div
                  key={`GalleryImage-${index}`}
                  style={{ position: "relative" }}
                >
                  <CustomAvatar
                    avatar={item.src ? getAPIEndpointUrl() + item.src : item.image}
                    imageStyle={{
                      width: 120,
                      height: 80,
                      minHeight: 80,
                      borderRadius: "5px",
                      objectFit: "cover",
                      cursor: "pointer",
                      marginRight: 1,
                      marginBottom: 1,
                    }}
                    handleClick={() => console.log("Click")}
                    alphaImageStyle={{
                      width: 100,
                      height: 80,
                      bgcolor: "#FFFFFF",
                    }}
                    child={<InsertPhotoIcon sx={{ fontSize: 60 }} />}
                  />
                  <IconButton
                    onClick={() => removeImage(index)}
                    style={{ position: "absolute", top: -5, right: 0, zIndex: 1 }}
                  >
                    <CloseIcon style={{color: '#ffffff'}}/>
                  </IconButton>
                </div>
              ))
            : RawImages.map((item, index) => (
                <div
                  key={`GalleryImage-${index}`}
                  style={{ position: "relative" }}
                >
                  <CustomAvatar
                    avatar={item.image}
                    imageStyle={{
                      width: 120,
                      height: 80,
                      minHeight: 80,
                      borderRadius: "5px",
                      objectFit: "cover",
                      cursor: "pointer",
                      marginRight: 1,
                      marginBottom: 1,
                    }}
                    handleClick={() => console.log("Click")}
                    alphaImageStyle={{
                      width: 100,
                      height: 80,
                      bgcolor: "#FFFFFF",
                    }}
                    child={<InsertPhotoIcon sx={{ fontSize: 60 }} />}
                  />
                  <IconButton
                    onClick={() => removeImage(index)}
                    style={{ position: "absolute", top: -5, right: 0, zIndex: 1 }}
                  >
                    <CloseIcon style={{color: '#ffffff'}}/>
                  </IconButton>
                </div>
              ))}
          <CustomAvatar
            // avatar={Images}
            imageStyle={{
              width: 120,
              height: 80,
              minHeight: 80,
              borderRadius: "5px",
              objectFit: "cover",
              cursor: "pointer",
              marginRight: 5,
            }}
            handleClick={() => ref.current.click()}
            alphaImageStyle={{ width: 100, height: 100, bgcolor: "#FFFFFF" }}
            child={<InsertPhotoIcon sx={{ fontSize: 40 }} />}
          />
        </div>
      </div>
    </div>
  );
}



 